const MetaTags = (tags) => {
    const elements = [...tags].reverse().map(tag => {
      let element = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (!element) {
        element = document.createElement('meta');
        if (tag.name) {
          element.name = tag.name;
        } else if (tag.property) {
          element.setAttribute('property', tag.property);
        }
        element.content = tag.content;
        document.head.insertBefore(element, document.head.firstChild);
      } else {
        element.content = tag.content;
      }
      return element;
    });
  
    const cleanupMetaTags = () => {
      elements.forEach(element => {
        if (document.head.contains(element)) {
          document.head.removeChild(element);
        }
      });
    };
  
    return cleanupMetaTags;
  };
  

export default MetaTags;